module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "slideshow"
  }, [_vm._l((_vm.slides), function(slide, index) {
    return _c('img', {
      attrs: {
        "data-visible": index === _vm.current,
        "src": _vm.shopifyImg(slide.src)
      }
    })
  }), _vm._v(" "), _c('button', {
    attrs: {
      "title": "Previous"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.slide('previous')
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "title": "Next"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.slide('next')
      }
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-570020dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slideshow.vue
// module id = 387
// module chunks = 1